export const replaceStoreQuery = (storeUuid?: string) => {
    const url = new URL(window.location.href);

    if (storeUuid) {
        url.searchParams.set('store', storeUuid);
    } else {
        url.searchParams.delete('store');
    }

    window.history.replaceState(window.history.state, '', url);
};
